<template>
  <div class="athleteDetail common_content">
    <div class="news_detail">
      <el-card class="box-card">
        <el-row :gutter="24">
          <el-col :xs="24" :sm="24" :md="24" v-if="evaluationContents">
            <div class="news_detail_top">
              <h3>{{name}}</h3>
              <p class="date">
                <!--<span style="padding:0px 10px;">性别：{{evaluationContents.sex == 0?'男':'女'}}</span>-->
                <!-- <span style="padding:0px 10px;">等级：{{evaluationContents.evaluator_rank |app_grade}}</span> -->
              </p>
              <span @click="goBack">返回</span>
            </div>
            <div class="grade_content" style=" width: 80%;margin: 0 auto;">
              <div class="grade_content_baseinfo">
                <span class="baseinfo">个人信息</span>
                <div class="baseinfo_preview">
                  <p>{{athleteData.name}}&nbsp;&nbsp;{{athleteData.sex}},{{athleteData.birthday}},{{athleteData.address}}</p>
                </div>
              </div>

              <div class="grade_content_testrecord">
                <span class="testRecord">羽毛球运动水平等级评定经历</span>
                <div class="testRecord_preview">
                  <template v-if="athleteData.testRecord.length>0">
                    <template v-for="(item,index) in athleteData.testRecord">
                      <p :key="index">{{index+1}}.{{item.testDate}}&nbsp;&nbsp;参加&nbsp;{{item.testClassName}}&nbsp;&nbsp;获得{{item.rankName}}</p>
                    </template>
                  </template>
                </div>
              </div>
              
              <div class="grade_content_zz">
                <span class="wz">证章</span>
                <div class="demo-image__preview">
                  <el-image
                    class="img"
                    :src="childImgUrl"
                    :preview-src-list="zzList"
                    v-if="childImgUrl"
                  ></el-image>
                  <el-image
                    class="img"
                    :src="adultImageUrl"
                    :preview-src-list="zzList"
                    v-else-if="adultImageUrl"
                  ></el-image>
                  <no-data v-else/>
                </div>
              </div>
              <div class="grade_content_zs">
                <span class="wz">证书</span>
                <div class="demo-image__preview">
                  <template v-if="zzZs.length>0">
                    <el-image
                      class="img"
                      :src="imgPath + item.certificate_url"
                      :preview-src-list="zsList"
                      v-for="(item,index) in zzZs"
                      :key="index"
                    ></el-image>
                  </template>
                  <no-data v-else />
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import noData from "@/views/admin/components/noData.vue";
import { GetAthleteDetail} from "@/api/admin/appraiser.js";  //,GetPersonalCertificate
export default {
  components: {
    noData
  },
  data() {
    return {
      evaluationContents: {},
      paging: {
        limit: 10,
        page: 1
      },
      gradeIdList:[],
      zzList: [],
      zsList: [],
      zzZs: [],
      childImgUrl: "",
      adultImageUrl: "",
      adult: [
        {
          grade: "4",
          base: 1
        },
        {
          grade: "5",
          base: 2
        },
        {
          grade: "6",
          base: 4
        },
        {
          grade: "7",
          base: 8
        },
        {
          grade: "8",
          base: 16
        },
        {
          grade: "9",
          base: 32
        }
      ],
      child: [
        {
          grade: "10",
          base: 1
        },
        {
          grade: "11",
          base: 2
        },
        {
          grade: "12",
          base: 4
        },
        {
          grade: "13",
          base: 8
        },
        {
          grade: "14",
          base: 16
        },
        {
          grade: "15",
          base: 32
        },
        {
          grade: "16",
          base: 64
        }
      ],
      value1: 0,
      value2: 0,
      adult_: "",
      child_: "",
      imgPath: window.apiObj.apiUrl,
      name:'',
      userid:{},
      athleteData:{},  //运动员基本信息+测试记录
    };
  },
  created() {
    this.path();
    this.dicData();

  },
  methods: {
    path() {
      var pathList = [
        { title: "您当前的位置" },
        { title: "首页", path: "/index" },
        { path: "/enquiry", title: "公开查询" },
        { path: "/enquiry/athleteList", title: "运动员列表" },
        { title: "运动员详情" }
      ];
      setTimeout(() => {
        this.$store.commit("SET_ROUTELIST", pathList);
      });
    },
    dicData() {
      this.name=this.$route.query.name;
      this.userid.userNumber=this.$route.query.id;
      this.gradeIdList = [];
      this.zsList = [];
      this.zzList = [];
      this.value1 = 0;
      this.value2 = 0;


GetAthleteDetail(Object.assign(this.userid)).then(data => {
        let list = data.data.result;
        window.console.warn("运动员详情数据", list)
        if (list.items.length > 0) {
          this.gradeIdList.push(list.items[0].certList.id);
          this.newCertificate = list.items[0].certList;
          this.zzZs = list.items[0].certList;
          this.athleteData = list.items[0];  // 运动员个人信息
          this.zzZs.forEach(i => {
            this.zsList.push(this.imgPath + i.certificate_url);
          });
          // 证章处理
          // 运动员 ----少儿，成人
          this.zzZs.forEach(i => {
            if (
              this.adult.some(record => {
                return record.grade == i.certificate_grade;
              })
            ) {
              this.adult_ = "adult_";
              this.adult.forEach(j => {
                if (j.grade == i.certificate_grade) {
                  this.value1 += j.base;
                }
              });
            } else if (
              this.child.some(record => {
                return record.grade == i.certificate_grade;
              })
            ) {
              this.child_ = "child_";
              this.child.forEach(j => {
                if (j.grade == i.certificate_grade) {
                  this.value2 += j.base;
                }
              });
            }
          });

          if (this.value1) {
            this.adultImageUrl =
              "/image/output/" + this.adult_ + this.value1 + ".png";
            this.zzList.push(this.adultImageUrl);
          }
          if (this.value2) {
            this.childImgUrl =
              "/image/output/" + this.child_ + this.value2 + ".png";
            this.zzList.push(this.childImgUrl);
          }
        }
      });


      // GetPersonalCertificate(Object.assign(this.userid)).then(data => {
      //   let list = data.data.result;
      //   if (list.items.length > 0) {
      //     this.gradeIdList.push(list.items[0].id);
      //     this.newCertificate = list.items;
      //     this.zzZs = list.items;
      //     this.zzZs.forEach(i => {
      //       this.zsList.push(this.imgPath + i.certificate_url);
      //     });
      //     // 证章处理
      //     // 运动员 ----少儿，成人
      //     this.zzZs.forEach(i => {
      //       if (
      //         this.adult.some(record => {
      //           return record.grade == i.certificate_grade;
      //         })
      //       ) {
      //         this.adult_ = "adult_";
      //         this.adult.forEach(j => {
      //           if (j.grade == i.certificate_grade) {
      //             this.value1 += j.base;
      //           }
      //         });
      //       } else if (
      //         this.child.some(record => {
      //           return record.grade == i.certificate_grade;
      //         })
      //       ) {
      //         this.child_ = "child_";
      //         this.child.forEach(j => {
      //           if (j.grade == i.certificate_grade) {
      //             this.value2 += j.base;
      //           }
      //         });
      //       }
      //     });

      //     if (this.value1) {
      //       this.adultImageUrl =
      //         "/image/output/" + this.adult_ + this.value1 + ".png";
      //       this.zzList.push(this.adultImageUrl);
      //     }
      //     if (this.value2) {
      //       this.childImgUrl =
      //         "/image/output/" + this.child_ + this.value2 + ".png";
      //       this.zzList.push(this.childImgUrl);
      //     }
      //   }
      // });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="less" scoped>
.athleteDetail {
  .news_detail {
    .news_detail_top {
      padding-top: 15px;
      width: 85%;
      margin: auto;
      position: relative;
      h3 {
        text-align: center;
        font-size: 20px;
        font-weight: normal;
      }
      .date {
        text-align: center;
        font-size: 14px;
        color: #8a8a8a;
        margin: 20px 0 25px 0;
        border-bottom: 1px solid #cdcccc;
        padding-bottom: 15px;
      }
      & > span {
        cursor: pointer;
        position: absolute;
        color: #f56c6c;
        top: 26%;
        right: 0;
      }
}
    .grade_content {
      .grade_content_zz{
        text-align: center;
        padding-bottom: 15px;
        .img {
          height: 20vw;
          width: 20vw;
          padding: 10px;
        }
      }
      .grade_content_zs {
        border-top: 2px solid #eee;
        text-align: center;
        padding-top: 15px;
        .img {
          height: 30vw;
          width: 20vw;
          padding: 10px;
        }
      }
      .grade_content_baseinfo{
        //border-bottom: 1px solid #cdcccc;
        padding-bottom: 15px;
        .baseinfo_preview{
          padding-left: 5%;
        }
      }
      .grade_content_testrecord{
        border-bottom: 1px solid #cdcccc;
        padding-bottom: 15px;
        margin-bottom: 15px;
      }
      .wz {
        display: block;
        text-align: left;
      }
    }
  }
}
</style>
